var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { FileDownloadType } from "@/share/FileRequest";
import { action, makeObservable, observable } from "mobx";
import { VersionDialogState } from "@/app/UIComponents/VersionDialog";
import { ReplaceDialogState } from "../UIComponents/ReplaceDialog";
import { MiniPdfViewerState } from "../UIComponents/MiniPDFViewer";
import { LetrwingCrypto } from "@@/LetrwingCommonCrypto";
import { DraftType } from "@@/Draft";
import { PdfPageStore } from "../UIComponents/PdfPagestore";
export var VirtuStatus;
(function (VirtuStatus) {
    VirtuStatus[VirtuStatus["Postive"] = 0] = "Postive";
    VirtuStatus[VirtuStatus["Negative"] = 1] = "Negative";
    VirtuStatus[VirtuStatus["Unknown"] = 2] = "Unknown";
})(VirtuStatus || (VirtuStatus = {}));
export class DocumentDetailStore {
    constructor() {
        this.downloading = false;
        this.show = false;
        this.title = "Document Details";
        this.loading = false;
        this.isViewable = false;
        this.hasVirus = VirtuStatus.Unknown;
        this.isexcel = false;
        this.hasviewercontent = false;
        this.loadingexcelcontent = false;
        this.pdfpagesdetails = [];
        this.isDownloadable = false;
        this.downloadProgress = 0;
        this.downloaderror = false;
        this.downloadpath = "";
        this.fetchingstatus = false;
        this.showvirustitle = false;
        this.loadpdfinfo = false;
        this.inqueue = false;
        this.showmetadata = false;
        this.orgname = "";
        this.keywords = [];
        this.summary = "";
        this.size = 0;
        this.waitingforpath = false;
        this.versionState = new VersionDialogState();
        this.editable = false;
        this.replaceState = new ReplaceDialogState();
        this.creatingdraft = false;
        this.menuopen = false;
        this.hassummary = false;
        this.haskeyword = false;
        this.showsummary = false;
        this.showcomments = false;
        this.showkeywords = false;
        this.gettingkeywords = false;
        this.gettingsummary = false;
        this.queued = false;
        this.showwatermakr = false;
        this.watermakr = "";
        this.showresumitbtn = false;
        this.showaddtoqueuebtn = false;
        this.addingtojobqueue = false;
        this.letrid = "";
        this.canedit = false;
        this.activeDocumentId = "";
        makeObservable(this);
        APPEvent.addSubscriberForActiveLetr((letr) => {
            this.letrid = letr;
            this.reset();
        });
        APPEvent.addSubscriberForPdfFilePage((res) => {
            var _a, _b, _c;
            if (res.ischooser) {
                return;
            }
            if (this.loadingexcelcontent && res.id === ((_a = this.info) === null || _a === void 0 ? void 0 : _a.fileid) &&
                res.pagename === 'viewer') {
                let page = "";
                if (res.page !== undefined) {
                    page = LetrwingCrypto.fromBase64ToUTF8(LetrwingCrypto.fromBase64ToUTF8(res.page));
                }
                APPEvent.publishSpreadsheetCon({
                    content: page,
                    readonly: true
                });
                this.setLoadingExcelContent(false);
            }
            else if (this.gettingkeywords && res.id === ((_b = this.info) === null || _b === void 0 ? void 0 : _b.fileid) &&
                res.pagename === "keyword") {
                this.keywords = [];
                if (res.page !== undefined) {
                    const kwords = LetrwingCrypto.fromBase64ToUTF8(res.page);
                    this.keywords = kwords.split("\n");
                }
                this.setLoadingKeywords(false);
            }
            else if (this.gettingsummary && res.id === ((_c = this.info) === null || _c === void 0 ? void 0 : _c.fileid) &&
                res.pagename === "summaryfile") {
                this.summary = "";
                if (res.page !== undefined) {
                    this.summary = LetrwingCrypto.fromBase64ToUTF8(res.page);
                }
                this.setLoadingSummary(false);
            }
        });
        APPEvent.addSubscriberForEditDocument((res) => {
            var _a, _b, _c;
            if (this.creatingdraft && res.letrid === ((_a = this.info) === null || _a === void 0 ? void 0 : _a.letrid) && res.fileid === ((_b = this.info) === null || _b === void 0 ? void 0 : _b.fileid)) {
                if (res.ok) {
                    if (res.project !== undefined) {
                        (_c = this.createEditedDraftCb) === null || _c === void 0 ? void 0 : _c.call(this, res.project);
                    }
                    APPEvent.publishApperror("Created new draft document");
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to create edit document");
                }
                this.setCreatingDraft(false);
            }
        });
        APPEvent.addSubscriberForDownload((res) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
            if (res.id === ((_a = this.info) === null || _a === void 0 ? void 0 : _a.fileid) &&
                res.letrid === this.info.letrid && !res.ischooser) {
                if (res.requesttype === FileDownloadType.Metadata) {
                    this.setDownloadable((_c = (_b = res.info) === null || _b === void 0 ? void 0 : _b.isDownloadable) !== null && _c !== void 0 ? _c : false);
                    this.enableWatermark(((_d = res.info) === null || _d === void 0 ? void 0 : _d.watermarkstr) !== undefined);
                    this.setWatermark((_g = (_f = (_e = res.info) === null || _e === void 0 ? void 0 : _e.watermarkstr) === null || _f === void 0 ? void 0 : _f.watermark) !== null && _g !== void 0 ? _g : '');
                    if ((_h = res.info) === null || _h === void 0 ? void 0 : _h.creatorid) {
                        this.info.creatorid = res.info.orgid + "__<<>>__" + res.info.creatorid;
                    }
                    else {
                        this.info.creatorid = undefined;
                    }
                    if (res.info !== undefined && res.info.ingestunboxed !== undefined) {
                        // this is where we can readd!
                        this.pdfpagesdetails = res.info.ingestunboxed.detail;
                        if (this.canedit) {
                            this.setHasViewerContent(res.info.ingestunboxed.hasviewer);
                        }
                        else {
                            this.setHasViewerContent(false);
                        }
                        if (!res.info.ingestunboxed.haspdf &&
                            res.info.ingestunboxed.hasviewer && res.info.ingestunboxed.isExcel) {
                            this.loadExcelContent();
                            this.setIsExcel(true);
                            MiniPdfViewerState.setShow(false);
                        }
                        else {
                            this.setViewable(res.info.ingestunboxed.haspdf);
                            this.setIsExcel(false);
                        }
                        if (res.info.ingestunboxed.hassummary) {
                            this.setHasSummary(true);
                            this.checkAndGetSummary();
                        }
                        else {
                            this.setHasSummary(false);
                        }
                        this.checkAndGetBookmarks();
                        if (res.info.ingestunboxed.haskeyword) {
                            this.setHasKeyword(true);
                            this.checkAndGetKeyWords();
                        }
                        else {
                            this.setHasKeyword(false);
                        }
                        this.checkAndGetFindDict();
                        this.setQueued(false);
                        this.setHasVirus(res.info.ingestunboxed.hasvirus ?
                            VirtuStatus.Negative : VirtuStatus.Postive);
                        MiniPdfViewerState.setPdfPageDetails(this.pdfpagesdetails);
                    }
                    else {
                        // this si where we can resubmit!
                        this.setViewable(false);
                        this.setHasVirus(VirtuStatus.Unknown);
                        // lets also do some more things
                        MiniPdfViewerState.setPdfPageDetails([]);
                        this.setHasViewerContent(false);
                        this.setQueued(true);
                        this.setShowAddToQueueBtn(!((_j = res.info) === null || _j === void 0 ? void 0 : _j.injobqueue) || (res.info.trial > 4));
                    }
                    MiniPdfViewerState.setActiveFileKey((_l = (_k = this.info) === null || _k === void 0 ? void 0 : _k.accesskey) !== null && _l !== void 0 ? _l : "");
                    MiniPdfViewerState.setActiveFileId((_o = (_m = this.info) === null || _m === void 0 ? void 0 : _m.fileid) !== null && _o !== void 0 ? _o : "");
                    PdfPageStore.activefileid = (_q = (_p = this.info) === null || _p === void 0 ? void 0 : _p.fileid) !== null && _q !== void 0 ? _q : "";
                }
                else if (res.requesttype === FileDownloadType.Download) {
                    // if (res.inqueue !== undefined && res.inqueue) {
                    //     this.setInQueue(true);
                    // } else {
                    //     this.setInQueue(false);
                    // }
                    // if (res.downloadfailed) {
                    //     this.errorDownloading(true);
                    //     this.setDownloading(false);
                    // } else if (res.downloadpath !== undefined) {
                    //     this.setDownloading(false);
                    // } else if (res.progress !== undefined) {
                    //     this.setDownloadProgress(res.progress);
                    // }
                }
                this.setLoading(false);
                this.setAddingToJobQueue(false);
            }
        });
        APPEvent.addSubscriberForNewLetr(() => {
            this.reset();
        });
        this.versionState.versionaddedcb = (vdetails) => {
            var _a;
            this.setTitle(vdetails.name);
            this.setDownloadable(vdetails.isDownloadable);
            (_a = this.versionaddedcb) === null || _a === void 0 ? void 0 : _a.call(this, vdetails);
        };
        this.replaceState.replaceaddcb = (rdetails) => {
            var _a;
            this.setTitle(rdetails.name);
            this.setDownloadable(rdetails.isDownloadable);
            (_a = this.replacecb) === null || _a === void 0 ? void 0 : _a.call(this, rdetails);
        };
    }
    addCurrentToJobQueue() {
        if (!this.addingtojobqueue && this.info) {
            this.setAddingToJobQueue(true);
            const req = {
                letrid: this.info.letrid,
                reference: this.info.fileid,
                accesskey: this.info.accesskey,
                ocr: true,
                ocrlang: '',
                name: this.orgname
            };
            Apphandler.sendMessage("addtojobqueue", req);
        }
    }
    setShowComments(show) {
        this.showcomments = show;
    }
    setShowKeywords(show) {
        this.showkeywords = show;
    }
    setshowresumitbtn(show) {
        this.showresumitbtn = show;
    }
    setShowAddToQueueBtn(show) {
        this.showaddtoqueuebtn = show;
    }
    setShowSummary(show) {
        this.showsummary = show;
    }
    setHasSummary(sum) {
        this.hassummary = sum;
    }
    setShowmetadata(show) {
        console.log(show);
        this.showmetadata = show;
    }
    setQueued(sum) {
        this.queued = sum;
    }
    setHasKeyword(key) {
        this.haskeyword = key;
    }
    setWatermark(mark) {
        this.watermakr = mark;
    }
    enableWatermark(enable) {
        this.showwatermakr = enable;
    }
    setAddingToJobQueue(adding) {
        this.addingtojobqueue = adding;
    }
    setInQueue(inqueue) {
        this.inqueue = inqueue;
    }
    setActiveDocumentId(id) {
        this.activeDocumentId = id;
    }
    resetVirusStatus() {
        this.hasVirus = VirtuStatus.Unknown;
    }
    setHasViewerContent(has) {
        this.hasviewercontent = has;
    }
    setShowVirusTitle(svt) {
        this.showvirustitle = svt;
    }
    editDocument(folderid) {
        var _a;
        if (this.info === undefined) {
            return;
        }
        this.setCreatingDraft(true);
        // now lets create a draft here and we done!
        // lets now do this
        const req = {
            letrid: (_a = this.info) === null || _a === void 0 ? void 0 : _a.letrid,
            folderid: folderid,
            type: this.isexcel ? DraftType.XLSX : DraftType.DOCX,
            fileid: this.info.fileid,
            accesskey: this.info.accesskey,
            name: this.title
        };
        Apphandler.sendMessage("createeditdocument", req);
    }
    loadExcelContent() {
        if (this.info === undefined) {
            return;
        }
        this.setLoadingExcelContent(true);
        const req = {
            id: this.info.fileid,
            pagename: "viewer",
            pagenumber: -1,
            accesskey: this.info.accesskey
        };
        Apphandler.sendMessage("pdfpage", req);
    }
    getVirusInfo() {
        if (this.hasVirus === VirtuStatus.Negative) {
            return "Virus found on this file";
        }
        if (this.hasVirus === VirtuStatus.Postive) {
            return "No virus found on this file";
        }
        if (this.hasVirus === VirtuStatus.Unknown) {
            return "No virus scan done on this file";
        }
    }
    setFetchingStatus(ft) {
        this.fetchingstatus = ft;
    }
    setHasVirus(vr) {
        this.hasVirus = vr;
    }
    setLoadingExcelContent(loading) {
        this.loadingexcelcontent = loading;
    }
    setIsExcel(excel) {
        this.isexcel = excel;
    }
    setViewable(vable) {
        this.isViewable = vable;
    }
    setDownloadPath(path) {
        this.downloadpath = path;
    }
    errorDownloading(error) {
        this.downloaderror = error;
    }
    setDownloadProgress(prog) {
        this.downloadProgress = prog;
    }
    setDownloadable(downloable) {
        this.isDownloadable = downloable;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setDownloading(downloading) {
        this.downloading = downloading;
    }
    setTitle(title) {
        this.title = title;
    }
    setShow(show) {
        this.show = show;
        if (!this.show) {
            this.reset(); // if hidding lets reset this..
        }
    }
    hide() {
        this.show = false;
    }
    openpath() {
    }
    setShowVersionDialog(show) {
        var _a, _b;
        this.versionState.clear();
        this.versionState.addVersions((_b = (_a = this.info) === null || _a === void 0 ? void 0 : _a.version) !== null && _b !== void 0 ? _b : []);
        this.versionState.setOpen(show);
    }
    setShowReplaceDialog(show) {
        var _a, _b;
        this.replaceState.clear();
        this.replaceState.addReplaces((_b = (_a = this.info) === null || _a === void 0 ? void 0 : _a.replace) !== null && _b !== void 0 ? _b : []);
        this.replaceState.activeversion = this.activereplace;
        this.replaceState.setOpen(show);
    }
    downloadToPath(queuid) {
        if (this.info === undefined) {
            return;
        }
        let filename = this.title;
        if (this.orgname && this.orgname != this.title) {
            const exti = this.title.lastIndexOf(".");
            let titlext = "";
            if (exti !== -1) {
                let ext = this.title.substring(exti + 1);
                if (ext) {
                    titlext = ext;
                }
            }
            const oexti = this.orgname.lastIndexOf(".");
            let oext = "";
            if (oexti !== -1) {
                let ext = this.orgname.substring(oexti + 1);
                if (ext) {
                    oext = ext;
                }
            }
            if (oext && oext !== titlext) {
                if (exti > -1) {
                    filename = filename.substring(0, exti);
                }
                filename += "." + oext;
            }
        }
        // this.setDownloadProgress(0);
        // this.setDownloadPath("");
        // this.errorDownloading(false);
        // this.setDownloading(true);
        const req = {
            letrid: this.info.letrid,
            id: this.info.fileid,
            requesttype: FileDownloadType.Download,
            size: this.size,
            info: {
                name: filename
            },
            accesskey: this.info.accesskey,
            boxid: this.info.boxid,
            savepath: "",
            downloadasset: true,
            queueid: queuid
        };
        Apphandler.sendMessage("downloadfile", req);
    }
    downloadAsset(queueid) {
        if (this.downloading || this.info === undefined) {
            return;
        }
        // this.setInQueue(true);
        this.downloadToPath(queueid);
    }
    downloadMetadata() {
        var _a;
        if (this.loading || this.info === undefined) {
            return;
        }
        this.setLoading(true);
        const req = {
            letrid: this.info.letrid,
            id: this.info.fileid,
            size: this.size,
            accesskey: (_a = this.info.accesskey) !== null && _a !== void 0 ? _a : "",
            requesttype: FileDownloadType.Metadata,
        };
        console.log(req);
        Apphandler.sendMessage("downloadfile", req);
    }
    fetchFileStatus() {
        var _a, _b, _c, _d;
        if (this.fetchingstatus) {
            return;
        }
        this.setFetchingStatus(true);
        const req = {
            id: (_b = (_a = this.info) === null || _a === void 0 ? void 0 : _a.fileid) !== null && _b !== void 0 ? _b : "",
            acceskey: (_d = (_c = this.info) === null || _c === void 0 ? void 0 : _c.accesskey) !== null && _d !== void 0 ? _d : ""
        };
        Apphandler.sendMessage("fileprocessstatus", req);
    }
    toggleMenu() {
        this.setMenuState(!this.menuopen);
    }
    setMenuState(state) {
        this.menuopen = state;
    }
    setCreatingDraft(cr) {
        this.creatingdraft = cr;
    }
    setLoadingKeywords(loading) {
        this.gettingkeywords = loading;
    }
    setLoadingSummary(loading) {
        this.gettingsummary = loading;
    }
    checkAndGetBookmarks() {
        if (this.info === undefined) {
            return;
        }
        const req = {
            id: this.info.fileid,
            pagename: "bookmarks",
            pagenumber: -1,
            accesskey: this.info.accesskey
        };
        Apphandler.sendMessage("pdfpage", req);
    }
    checkAndGetSummary() {
        if (this.info === undefined) {
            return;
        }
        this.setLoadingSummary(true);
        const req = {
            id: this.info.fileid,
            pagename: "summaryfile",
            pagenumber: -1,
            accesskey: this.info.accesskey
        };
        Apphandler.sendMessage("pdfpage", req);
    }
    checkAndGetFindDict() {
        if (this.info === undefined) {
            return;
        }
        this.setLoadingKeywords(true);
        const req = {
            id: this.info.fileid,
            pagename: "finddict",
            pagenumber: -1,
            accesskey: this.info.accesskey
        };
        Apphandler.sendMessage("pdfpage", req);
    }
    checkAndGetKeyWords() {
        if (this.info === undefined) {
            return;
        }
        this.setLoadingKeywords(true);
        const req = {
            id: this.info.fileid,
            pagename: "keyword",
            pagenumber: -1,
            accesskey: this.info.accesskey
        };
        Apphandler.sendMessage("pdfpage", req);
    }
    reset() {
        this.setShowmetadata(false);
        this.setLoading(false);
        this.setDownloading(false);
        this.info = undefined;
        this.hide();
        this.errorDownloading(false);
        this.setDownloadPath("");
        this.waitingforpath = false;
        this.setActiveDocumentId("");
        this.setLoadingExcelContent(false);
        this.setCreatingDraft(false);
        this.setIsExcel(false);
        this.setHasKeyword(false);
        this.setHasSummary(false);
        this.setShowKeywords(false);
        this.setLoadingKeywords(false);
        this.keywords = [];
        this.summary = "";
        this.setLoadingSummary(false);
        this.setShowComments(false);
        this.pdfpagesdetails = [];
        this.title = "";
        this.setShowAddToQueueBtn(false);
        this.setshowresumitbtn(false);
        this.setAddingToJobQueue(false);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "downloading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "title", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "isViewable", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "hasVirus", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "isexcel", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "hasviewercontent", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "loadingexcelcontent", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "isDownloadable", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "downloadProgress", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "downloaderror", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "downloadpath", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "fetchingstatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "showvirustitle", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "loadpdfinfo", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "inqueue", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "showmetadata", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "creatingdraft", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "menuopen", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "hassummary", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "haskeyword", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "showsummary", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "showcomments", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "showkeywords", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "gettingkeywords", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "gettingsummary", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "queued", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "showwatermakr", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "watermakr", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "showresumitbtn", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "showaddtoqueuebtn", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DocumentDetailStore.prototype, "addingtojobqueue", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], DocumentDetailStore.prototype, "activeDocumentId", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setShowComments", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setShowKeywords", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setshowresumitbtn", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setShowAddToQueueBtn", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setShowSummary", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setHasSummary", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setShowmetadata", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setQueued", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setHasKeyword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setWatermark", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "enableWatermark", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setAddingToJobQueue", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setInQueue", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setActiveDocumentId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "resetVirusStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setHasViewerContent", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setShowVirusTitle", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "getVirusInfo", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setFetchingStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setHasVirus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setLoadingExcelContent", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setIsExcel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setViewable", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setDownloadPath", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "errorDownloading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setDownloadProgress", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setDownloadable", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setDownloading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setTitle", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setShow", null);
__decorate([
    action // use this is just want to hide but dont want to reset
    ,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "hide", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setMenuState", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setCreatingDraft", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setLoadingKeywords", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "setLoadingSummary", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DocumentDetailStore.prototype, "reset", null);
